(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-belgium-language-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('pl-be-language');
    if (!popup) return;
    const params = new URLSearchParams(window.location.search);
    const preview = popup.dataset.draft === 'true' && params.get('pl_language_preview') === '1';
    const preferenceKey = 'pl_be_language_choice_v1';
    let dismissed = false;
    const hasChoice = () => {
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try {
          const choice = JSON.parse(window[storageName].getItem(preferenceKey));
          if (choice && ['fr', 'nl'].includes(choice.language) && choice.expires > Date.now()) return true;
        } catch {}
      }
      return false;
    };
    const remember = (language) => {
      if (preview) return;
      const value = JSON.stringify({ language, expires: Date.now() + 30 * 86400000 });
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try { window[storageName].setItem(preferenceKey, value); } catch {}
      }
    };
    const dismiss = () => {
      dismissed = true;
      popup.hidden = true;
      remember('fr');
    };
    popup.querySelectorAll('[data-pl-language-dismiss]').forEach(button => button.addEventListener('click', dismiss));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) dismiss();
    });
    const form = popup.querySelector('form');
    form.addEventListener('submit', () => {
      dismissed = true;
      remember('nl');
      const returnTo = form.querySelector('[name="return_to"]');
      const search = new URLSearchParams(window.location.search);
      search.delete('pl_language_preview');
      if (returnTo) returnTo.value = window.location.pathname + (search.size ? '?' + search.toString() : '') + window.location.hash;
    });
    document.addEventListener('click', event => {
      const option = event.target.closest('[data-value]');
      if (!option || !['fr', 'nl'].includes(option.dataset.value)) return;
      const localizationForm = option.closest('form');
      if (!localizationForm?.querySelector('[name="language_code"], [name="locale_code"]')) return;
      dismissed = true;
      popup.hidden = true;
      remember(option.dataset.value);
    }, true);
    const show = () => {
      if (dismissed || (!preview && hasChoice())) return;
      if (document.visibilityState !== 'visible') return;
      if ([...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => element.getClientRects().length > 0)) return;
      if (document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open')) return;
      popup.hidden = false;
    };
    if (preview) {
      show();
      return;
    }
    const preferredLanguage = (navigator.languages?.[0] || navigator.language || '').toLowerCase().split('-')[0];
    if (preferredLanguage !== 'nl' || hasChoice()) return;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 2500);
    const root = popup.dataset.root.replace(/\/?$/, '/');
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
      credentials: 'same-origin',
      signal: controller.signal,
      headers: { Accept: 'application/json' }
    })
      .then(response => response.ok ? response.json() : null)
      .then(context => {
        if (context?.detected_values?.country?.handle === 'BE') window.setTimeout(show, 2000);
      })
      .catch(() => {})
      .finally(() => window.clearTimeout(timeout));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-stock-alternatives"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-pl-stock-alternatives]').forEach(function(module) {
      const id = String(variant.id);
      if (!module.dataset.variantIds.split(',').includes(id)) return;
      let visible = false;
      module.querySelectorAll('[data-alternative-for]').forEach(function(panel) {
        const selected = panel.dataset.alternativeFor === id && !variant.available;
        panel.hidden = !selected;
        visible = visible || selected;
      });
      module.hidden = !visible;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-bar"] && !Shopify.designMode) return;
  try {
    function preservePatisslandSearchType() {
    const searchType = new URLSearchParams(window.location.search).get('type');
    if (!searchType || !searchType.split(',').every(type => ['product', 'article', 'page'].includes(type))) return;
    document.querySelectorAll('form.search-bar input[name="type"]').forEach(input => { input.value = searchType; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preservePatisslandSearchType);
  else preservePatisslandSearchType();
  document.addEventListener('shopify:section:load', preservePatisslandSearchType);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (function(){
  function initializeStickyAtc(){
  var bar = document.getElementById('pl-atc');
  if (!bar || bar.dataset.ready) return;
  bar.dataset.ready = 'true';
  var mainForm = document.querySelector('#MainContent .product-single__form');
  if (!mainForm) return;
  var realBtn = mainForm.querySelector('[data-add-to-cart]');
  if (!realBtn) return;
  var container = mainForm.closest('[data-section-type="product"]') || mainForm.closest('[data-section-id]');
  if (!container) return;
  var button = bar.querySelector('#pl-atc-btn');
  var name = bar.querySelector('#pl-atc-name');
  var price = bar.querySelector('#pl-atc-price');
  var heading = container.querySelector('h1');
  var priceSource = container.querySelector('[data-product-price]');
  var buttonLabel = realBtn.querySelector('[data-add-to-cart-text]') || realBtn;
  var mobile = window.matchMedia('(max-width: 768px)');
  var passedButton = false;
  function text(value){ return (value || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim(); }
  function busy(){ return realBtn.classList.contains('btn--loading') || realBtn.getAttribute('aria-busy') === 'true'; }
  function disabled(){ return realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true' || busy(); }
  function sync(){
    if (heading) name.textContent = text(heading.textContent);
    price.textContent = text(priceSource && priceSource.textContent) || text(price.dataset.fallback);
    button.textContent = text(buttonLabel.textContent);
    button.disabled = disabled();
    button.setAttribute('aria-busy', String(busy()));
  }
  function visibility(){
    var blocked = /js-drawer-open|js-modal-open|modal-open/.test(document.documentElement.className + ' ' + document.body.className);
    var assistant = document.getElementById('pl-bot-panel');
    if (assistant && assistant.classList.contains('plb-open')) blocked = true;
    var visible = mobile.matches && passedButton && !blocked;
    bar.classList.toggle('pl-show', visible);
    bar.setAttribute('aria-hidden', String(!visible));
    document.documentElement.classList.toggle('pl-sticky-atc-visible', visible);
    if (visible) document.documentElement.style.setProperty('--pl-sticky-atc-height', bar.offsetHeight + 'px');
  }
  sync();
  new MutationObserver(sync).observe(mainForm, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy','class']});
  if (priceSource) new MutationObserver(sync).observe(priceSource, {childList:true,characterData:true,subtree:true});
  if (heading) new MutationObserver(sync).observe(heading, {childList:true,characterData:true,subtree:true});
  var visibilityObserver = new MutationObserver(visibility);
  visibilityObserver.observe(document.documentElement, {attributes:true,attributeFilter:['class']});
  visibilityObserver.observe(document.body, {attributes:true,attributeFilter:['class']});
  var assistantPanel = document.getElementById('pl-bot-panel');
  if (assistantPanel) new MutationObserver(visibility).observe(assistantPanel, {attributes:true,attributeFilter:['class','style']});
  button.addEventListener('click', function(){ if (!disabled()) realBtn.click(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries){
      passedButton = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom <= 0;
      visibility();
    }, {threshold:0}).observe(realBtn);
  } else {
    window.addEventListener('scroll', function(){ passedButton = realBtn.getBoundingClientRect().bottom <= 0; visibility(); }, {passive:true});
  }
  if (mobile.addEventListener) mobile.addEventListener('change', visibility);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeStickyAtc);
  else initializeStickyAtc();
})();
  } catch(e) { console.error(e); }
})();

})();
